const BANNER_TYPE = {
  INFORMATIONAL: "INFORMATIONAL",
  PROBLEM: "PROBLEM",
  WARNING: "WARNING",
  REWARD: "REWARD",
};

export { BANNER_TYPE };
